export default "__VITE_ASSET__36a434dc__"